import solveCaptcha, { isCaptchaChallenge } from 'sign_up/captcha'

export const GENERIC_ERROR = 'Something went wrong, please try again'

// Without the WAF SDK (dev, test, or challenge.js failed to load) this is a plain fetch.
function wafFetch (url, options) {
  if (window.AwsWafIntegration) {
    return window.AwsWafIntegration.fetch(url, options)
  }
  return window.fetch(url, options)
}

function postSignUp (form, { signUpUrl }) {
  const headers = { Accept: 'application/json' }
  // Absent when forgery protection is off (the test env), so Rails renders no token field.
  const csrfField = form.querySelector('input[name="authenticity_token"]')
  if (csrfField) headers['X-CSRF-Token'] = csrfField.value

  return wafFetch(signUpUrl, {
    method: 'POST',
    credentials: 'same-origin',
    headers,
    body: new FormData(form)
  })
}

// Mirrors the markup FormHelper#error_messages renders server-side.
export function showErrors (form, messages) {
  clearErrors(form)
  const list = document.createElement('ul')
  list.className = 'flash alert'
  messages.forEach(message => {
    const item = document.createElement('li')
    item.textContent = message
    list.appendChild(item)
  })
  form.insertBefore(list, form.querySelector('.email'))
}

function clearErrors (form) {
  form.querySelectorAll('ul.flash.alert').forEach(list => list.remove())
}

function captchaContainer (form) {
  let container = form.querySelector('.sign-up-captcha')
  if (!container) {
    container = document.createElement('div')
    container.className = 'sign-up-captcha'
    form.insertBefore(container, form.querySelector('.actions'))
  }
  container.innerHTML = ''
  return container
}

async function handleResponse (form, config, response) {
  if (response.ok) {
    const { redirect_to: redirectTo } = await response.json()
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'CompleteRegistration')
    }
    window.location.assign(redirectTo)
    return true
  }

  if (response.status === 422) {
    const { errors } = await response.json()
    showErrors(form, errors)
    return false
  }

  if (isCaptchaChallenge(response) && config.captchaUrl && config.captchaApiKey) {
    const container = captchaContainer(form)
    await solveCaptcha(container, config)
    container.remove()
    return handleResponse(form, config, await postSignUp(form, config))
  }

  showErrors(form, [GENERIC_ERROR])
  return false
}

// config: { signUpUrl, captchaUrl, captchaApiKey, integrationReady }
export default async function submitSignUp (form, config) {
  const button = form.querySelector('[type="submit"]')
  // Disabling synchronously also keeps jquery_ujs's data-disable-with handler off this button:
  // it only targets :enabled elements, and would otherwise never re-enable it (no page load).
  button.disabled = true
  clearErrors(form)

  let redirecting = false
  try {
    await config.integrationReady
    redirecting = await handleResponse(form, config, await postSignUp(form, config))
  } catch (error) {
    showErrors(form, [GENERIC_ERROR])
  } finally {
    // Leave it disabled while the browser navigates away so it can't be double-submitted.
    if (!redirecting) button.disabled = false
  }
}
